import { render, staticRenderFns } from "./KeySectors.vue?vue&type=template&id=4f5e7dd4&scoped=true"
import script from "./KeySectors.vue?vue&type=script&lang=js"
export * from "./KeySectors.vue?vue&type=script&lang=js"
import style0 from "./KeySectors.vue?vue&type=style&index=0&id=4f5e7dd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5e7dd4",
  null
  
)

export default component.exports